const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function trackPageView() {
  if (!measurementId || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
    ...(process.env.NODE_ENV !== "production" ? { debug_mode: true } : {}),
  });
}

export function trackEvent(name, parameters = {}) {
  if (!measurementId || typeof window.gtag !== "function") return;
  window.gtag("event", name, parameters);
}
